export enum UserInteractionEventName {
  openInCanvasButtonClicked = "open_in_canvas_button_clicked",
  webmcpToolInvoked = "webmcp_tool_invoked",
}

export const UserInteractionEvent =
  "web_analytics.tracking.user_interaction.UserInteractionEvent";

// constants for ZapEntryPointEvent and ZapCreationRequestSuccessEvent
// in the service or as query params via webintent
export const ENTRY_POINT_METHOD_QUERY_PARAM = "entry-point-method";
export const ENTRY_POINT_LOCATION_QUERY_PARAM = "entry-point-location";
export const ENTRY_POINT_METHOD = "zap_template";
export const ENTRY_POINT_LOCATION = "templates_home";
